// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"We","innerTile":"Xe","heading":"Ye","instaTileBtn":"Ze","disabled":"_e","instaTileElement":"af","instagramPic":"bf"};